<template>
  <div class="h-full bg-documentGray">
    <div class="w-full">
      <TopAppBarDrawer
        :isDrawerOpen="isDrawerOpen"
        @closeDrawer="closeDrawer"
      ></TopAppBarDrawer>
      <header
        class="mdc-top-app-bar mdc-top-app-bar--fixed board-header"
        id="app-bar"
        ref="appBar"
        :style="showing"
      >
        <div class="mdc-top-app-bar__row">
          <section
            class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start"
          >
            <div
              class="material-icons mdc-top-app-bar__navigation-icon"
              @click="openDrawer()"
              @keypress="openDrawer()"
              tabindex="0"
            >
              menu
            </div>
          </section>

          <section class="mdc-top-app-bar__section title">
            <div class="mdc-top-app-bar__title">{{ $t("3332") }}</div>
          </section>

          <section
            class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end"
          >
            <div
              class="material-icons mdc-top-app-bar__action-item t-color-logoBlue"
              aria-label="search"
              alt="search"
              @click="searchOpen"
              @keypress="searchOpen"
              tabindex="0"
            >
              search
            </div>
          </section>
        </div>
      </header>
      <header class="mdc-top-app-bar" :style="hiding">
        <div class="mdc-top-app-bar__row">
          <section
            class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start"
            @click="searchClose()"
            @keypress="searchClose()"
            tabindex="0"
          >
            <button
              class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button"
              aria-label="Open navigation menu"
            >
              close
            </button>
          </section>
          <section class="mdc-top-app-bar__section title d-flex w-full">
            <div class="mdc-top-app-bar__title pdl-1 font-r w-full pdl-8">
              <input
                type="text"
                :placeholder="$t('3332')"
                class="search_form w-full t-color-tabColor border-none t-subtitle6"
                v-model="contents"
                autofocus
                @keyup="getStoreSerach"
              />
            </div>
          </section>
          <section
            class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end"
            role="toolbar"
            @click="search()"
            @keypress="search()"
            tabindex="0"
          >
            <button
              class="material-icons mdc-top-app-bar__action-item mdc-icon-button"
              aria-label="Search"
            >
              search
            </button>
          </section>
        </div>
      </header>
    </div>

    <main
      class="mdc-top-app-bar--fixed-adjust bg-documentGray board_module list"
    >
      <!-- <div class="pdt-16 pdb-8 pdl-16 pdr-16">
        <div v-if="isAllHide==true" class="t-subtitle3 l-spacing48 font-m">{{$t('3338')}}</div>
        <div v-else class="t-subtitle3 l-spacing48 font-m">{{categoryName}}</div>
      </div> -->
      <div class="pdl-8 pdb-8 pdr-8 pdt-8">
        <div
          class="mdc-chip-set banner--chip chip--outlined top-chip"
          role="grid"
        >
          <div
            v-bind:class="['mdc-chip', { checked: isAll }]"
            role="row"
            @click="getBoard('ALL', '')"
            @keypress="getBoard('ALL', '')"
            tabindex="0"
          >
            <div class="mdc-chip__ripple"></div>
            <i
              class="material-icons mdc-chip__icon mdc-chip__icon--leading mgr-2 t-color-logoBlue"
              v-if="isAll"
              >check</i
            >
            <span role="gridcell">
              <span class="mdc-chip__text t-body4">{{ $t("3333") }}</span>
            </span>
          </div>
          <!-- <div class="mdc-chip" v-bind:class="['mdc-chip', { 'checked' :ischecked(board.id)}]" v-for="(board) in uniqueCategory" :key="board.id + '-name'" role="row" @click="getBoard(board.id)"> -->
          <div
            class="mdc-chip"
            v-bind:class="['mdc-chip', { checked: ischecked(board.value) }]"
            v-for="board in categoryList"
            :key="board.value + '-name'"
            role="row"
            @click="getBoard(board.value)"
            @keypress="getBoard(board.value)"
            tabindex="0"
          >
            <div class="mdc-chip__ripple"></div>
            <i
              class="material-icons mdc-chip__icon mdc-chip__icon--leading mgr-2 t-color-logoBlue"
              v-if="ischecked(board.value)"
              >check</i
            >
            <span role="gridcell">
              <span class="mdc-chip__text t-body4 font-r">{{
                board ? board.text : ""
              }}</span>
            </span>
          </div>
        </div>
      </div>
      <div
        class="pdl-16 pdr-16"
        v-if="isAllHide == true && searchNoData == false"
      >
        <!-- <div class="divider"></div> -->
      </div>
      <!----------------- Recent Serach suggestion Box ---------------------->
      <div class="recent-search" v-if="suggestionBox == true">
        <!-- <div class="pdl-16 pdr-16">
          <div class="divider"></div>
        </div> -->
        <div
          class="pda-16 t-body3 t-color-bodyGrayA"
          v-if="storeSearch && storeSearch.length > 0"
        >
          {{ $t("3127") }}
        </div>
        <!-- <div v-if="contents"> -->
        <div>
          <div v-for="(searchData, k) in storeSearch" :key="k.id">
            <div class="pdl-16 pdr-16 pdt-12 pdb-12">
              <div
                class="d-flex align-items-center justify-content-between search-list"
              >
                <div class="d-flex">
                  <i class="material-icons t-color-iconInactive pdr-8"
                    >history</i
                  >
                  <div
                    class="t-body3 font-r"
                    @click="setValueInSearch(searchData)"
                    @keypress="setValueInSearch(searchData)"
                    tabindex="0"
                  >
                    {{ searchData }}
                  </div>
                </div>
                <div
                  @click="removeRecentSeachValue(k)"
                  @keypress="removeRecentSeachValue(k)"
                  tabindex="0"
                >
                  <i class="material-icons t-color-iconInactive">close</i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-------------------- End Here ----------------------------------------->

      <NoData
        class="pdt-32 pdb-16 pdl-16 pdr-16"
        v-if="isNoData"
        :contents="contents"
        :suggestionBox="suggestionBox"
      ></NoData>
      <div
        class="mgt-30 no-board-data t-center"
        v-else-if="searchNoData && isNoData && suggestionBox == false"
      >
        <div>
          <div class="t-subtitle3 font-m">{{ $t("3339") }}</div>
          <div class="t-body3 font-r t-color-bodyGrayA mgt-8">
            {{ $t("3340") }}
          </div>
        </div>
      </div>
      <div class="pdt-8 pdl-16 pdr-16 pdb-16" v-if="suggestionBox == false">
        <div
          class="mdc-card position-relative mgb-16"
          v-for="(checklist, index2) in listData"
          :key="index2"
          @click.prevent="moveToDetail(checklist)"
          @keypress.prevent="moveToDetail(checklist)"
          tabindex="0"
        >
          <div class="pdt-12 pdl-12 pdr-12 pdb-4 d-flex">
            <div
              class="mdc-chip-set mdc-chip-set--choice chip--tag-type p-0 mdc-chip-disabled"
              @click.stop=""
              @keypress.stop=""
            >
              <div class="demo-chip mdc-chip bg-lecturePurpleBG16">
                <!-- <div class="mdc-chip__ripple"></div>        -->
                <div
                  class="mdc-chip__text t-helper font-r t-color-lecturePurple"
                >
                  {{ checklist.distribution.checklistPaper.hcategory.text }}
                </div>
              </div>
            </div>
            <div
              class="mdc-chip-set mdc-chip-set--choice chip--tag-type p-0 mdc-chip-disabled"
              @click.stop=""
              @keypress.stop=""
            >
              <div class="demo-chip mdc-chip bg-lectureYellowBG16">
                <!-- <div class="mdc-chip__ripple"></div>        -->
                <div
                  class="mdc-chip__text t-helper font-r t-color-lectureYellow"
                >
                  {{
                    checklist.distribution.checklistPaper.hcategory.child.text
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="pdl-16 pdr-16">
            <div class="t-body1 t-line-h-24 l-spacing48 font-r">
              {{ checklist.distribution.name }}
            </div>
            <div class="t-body3 font-r t-color-bodyGrayA t-line-h-19 mgt-12">
              {{
                $moment(checklist.distribution.periodPolicy.post.start).format(
                  "L"
                )
              }}
              ~
              {{
                $moment(checklist.distribution.periodPolicy.post.end).format(
                  "L"
                )
              }}
            </div>
          </div>
          <div class="pda-8 d-flex justify-content-between">
            <button
              class="mdc-button mdc-button--leading t-color-bodyGrayA"
              @click.stop=""
              @keypress.stop=""
              disabled
              tabindex="0"
            >
              <!-- <span class="mdc-button__ripple"></span> -->
              <i class="material-icons mdc-button__icon" aria-hidden="true"
                >playlist_add_check</i
              >
              <span class="mdc-button__label t-body4 l-spacing39 font-r">{{
                $t("3334", { str: checklist.submissionsCount })
              }}</span>
            </button>
            <button
              class="mdc-button mdc-button--leading t-color-keyBlue"
              disabled
              @click.stop=""
              @keypress.stop=""
              v-if="
                checklist.activeRespondentPaper &&
                checklist.activeRespondentPaper.status === 'SOLVING' &&
                checklist.distribution.status.value === 'DEPLOYING'
              "
              tabindex="0"
            >
              <span class="mdc-button__ripple"></span>
              <i class="material-icons mdc-button__icon" aria-hidden="true"
                >create</i
              >
              <span class="mdc-button__label t-body4 l-spacing39 font-r">{{
                $t("3335")
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </main>

    <infinite-loading
      @infinite="fetchData"
      :identifier="infiniteId"
      spinner="spiral"
    >
      <div slot="no-more" class="mgt-16"></div>
      <div slot="no-results" class="mgt-16"></div>
    </infinite-loading>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import checklistApi from "@/api/checklistApi.js";
import NoData from "../common/NoDataCheckList.vue";
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    InfiniteLoading,
    TopAppBarDrawer,
    NoData,
  },

  data() {
    return {
      status: "",
      isAll: true,
      isAllHide: false,
      isNoData: false,
      isDrawerOpen: false,
      fixListDataList: false,
      permissionAccess: false,
      campaignData: null,
      mamberData: null,
      userAuthData: null,
      selectedChild: null,
      listData: [],
      listData1: [],
      fixListData: [],
      selectedBoard: [],
      selectBoardCategory: null,
      filterCategory: null,
      categoryList: "",
      boardId: null,
      boardName: null,
      headerBoardName: null,
      categoryName: null,
      contents: "",
      menuBar: null,
      menuTypeTitle: this.$t("3119"),
      selectedMenuType: "ALL",
      showing: { display: "block" },
      hiding: { display: "none" },
      suggestionBox: false,
      storeSearch: [],
      currentPage: 1,
      totalPages: 1,
      infiniteId: +new Date(),
      firstCharOfNames: localStorage.getItem("firstChar"),
      bgColorOfName: localStorage.getItem("bgColors"),
      searchNoData: false,
      searchClick: false,
    };
  },

  mixins: [topAppBarMixin],

  computed: {
    uniqueCategory() {
      let temp = [];
      this.listData1.forEach((item) => {
        item.boardDto.boardCategory.childCategory.forEach((arra) => {
          temp.push(arra);
        });
      });
      var flags = [],
        output = [],
        l = temp.length,
        i;
      for (i = 0; i < l; i++) {
        if (flags[temp[i].id]) continue;
        flags[temp[i].id] = true;
        output.push({
          id: temp[i].id,
          name: temp[i].name,
        });
      }
      return output;
    },
  },

  watch: {
    $route(to, from) {
      this.closeDrawer();
      this.initData();
      this.getCategoryList();
    },
  },

  mounted() {
    this.getCategoryList();
  },

  methods: {
    initData() {
      this.listData = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1;
    },
    listFilter(str) {
      let length = 90;
      let ending = " ...";
      let str1 = "";
      if (str) {
        let str2 = str.replace(/<a [^>]+>[^<]*<\/a>/, "");
        let strRemoveBrTag = str2.replace(/<\/?[^>]+>/gi, " ");
        let strRemoveImgTags = strRemoveBrTag.replace(/<img[^>]*>/gi, "");
        let strRemoveRNTags = strRemoveImgTags.replace(/(\r\n|\n|\r)/gm, "");
        if (strRemoveRNTags.length > length) {
          str1 = strRemoveRNTags.substring(0, length - ending.length) + ending;
          return str1;
        } else {
          return str.replace(/(\r\n|\n|\r)/gm, "<br/>");
        }
      } else {
        return str.replace(/(\r\n|\n|\r)/gm, "<br/>");
      }
    },

    getCategoryList() {
      //checklistApi.fetchCategoryList(this.$route.params).then(response => {
      checklistApi
        .fetchCategoryList()
        .then((response) => {
          this.categoryList = response.data.data;
          console.log("categoryList", this.categoryList);
        })
        .catch((err) => {
          console.log("err=>", err);
        });
    },

    // 목록 데이터 로딩(get list data)
    fetchData($state) {
      let responseData = null;
      let params = this.setParams();

      if (this.totalPages >= this.currentPage) {
        checklistApi
          .fetchList(params)
          .then((response) => {
            console.log("response", response);
            responseData = response.data.data;
            this.listData = this.listData.concat(responseData.content);
            this.listData1 = this.listData;
            this.currentPage++;
            this.totalPages = responseData.totalPages;

            if (responseData.content.length) {
              $state.loaded();
            } else {
              $state.complete();
            }
            if (
              this.contents &&
              this.listData.length > 0 &&
              this.searchClick == true
            ) {
              this.searchNoData = false;
              this.searchClick = false;
            } else if (
              this.contents &&
              this.listData.length <= 0 &&
              this.searchClick == true
            ) {
              this.searchNoData = true;
              this.searchClick = false;
            } else {
              this.searchNoData = false;
              this.searchClick = false;
            }
            if (this.listData.length > 0) {
              this.isNoData = false;
              this.filterCategory = "";
            } else {
              this.isNoData = true;
              this.filterCategory = "";
            }
          })
          .catch((err) => {
            $state.error();
          });
      } else {
        $state.complete();
      }
    },

    // 파라미터 설정(set parameter)
    setParams() {
      if (this.isAll == true) {
        const params = {
          name: this.contents,
          // subject:this.contents,
          // contents: this.contents,
          // statuses:'',
          // type:this.selectedMenuType,
          categoryId: "",
          page: this.currentPage,
          size: 10,
          sort: "id,desc",
        };
        return params;
      } else {
        const params = {
          name: this.contents,
          // subject:this.contents,
          // contents: this.contents,
          // statuses:'',
          // type:this.selectedMenuType,
          categoryId: this.selectBoardCategory,
          page: this.currentPage,
          size: 10,
          sort: "id,desc",
        };
        return params;
      }
    },

    // Board Category
    getBoard(selectedBoardId) {
      this.selectBoardCategory = selectedBoardId;
      if (this.selectBoardCategory == "ALL") {
        this.filterCategory = "";
        this.isAll = true;
      } else {
        this.isAll = false;
        this.filterCategory = this.selectBoardCategory;
      }

      this.initData();
      //this.getStaticData()
    },

    ischecked(checkecdBoardId) {
      // if(this.selectBoardCategory)
      // this.isAll=false;

      return this.selectBoardCategory == checkecdBoardId;
      // return this.selectedBoard.find(arr=>arr==checkecdBoardId)? true:false
    },

    // check type of video and image
    getType(contentType) {
      if (contentType) {
        return contentType.split("/")[0];
      }
    },

    searchOpen() {
      this.suggestionBox = true;
      this.isAllHide = true;
      this.showing = { display: "none" };
      this.hiding = { display: "block" };
      this.storeSearch = JSON.parse(localStorage.getItem("datas"));
    },

    searchClose() {
      this.suggestionBox = false;
      this.isAllHide = false;
      this.fixListDataList = false;
      this.searchClick = false;
      this.contents = "";
      this.initData();
      //this.$router.go(this.$router.currentRoute)
      this.showing = { display: "block" };
      this.hiding = { display: "none" };
    },

    search() {
      //localStorage.removeItem('datas')
      this.suggestionBox = false;
      this.fixListDataList = true;
      this.isAllHide = true;
      this.initData();
      this.searchClick = true;
      //this.getStaticData();
      this.showing = { display: "none" };
      this.hiding = { display: "block" };
      let tempArray = [];
      if (this.contents) {
        // console.log('search data')
        if (localStorage.getItem("datas")) {
          tempArray = JSON.parse(localStorage.getItem("datas"));
        }
        tempArray.push(this.contents);
        localStorage.setItem("datas", JSON.stringify(tempArray));
        // console.log(tempArray, ' ___tempArray')
      } else {
        this.searchNoData = true;
      }
    },

    // Recent Serach Suggestion
    getStoreSerach() {
      this.suggestionBox = true;
      let charSearch = JSON.parse(localStorage.getItem("datas"));
      let searchResult = charSearch.includes(this.contents);
      if (searchResult === true) {
        this.storeSearch = charSearch;
      } else {
        this.searchNoData = true;
        this.storeSearch = "";
      }
    },

    setValueInSearch(searchData) {
      this.contents = searchData;
      this.suggestionBox = false;
      //this.fixListDataList = true
      this.initData();
      //this.getStaticData();
    },

    // Removed value from Recent Serach Suggestion
    removeRecentSeachValue(index) {
      this.storeSearch.splice(index, 1);
      localStorage.setItem("datas", JSON.stringify(this.storeSearch));
    },

    openDrawer() {
      this.isDrawerOpen = true;
    },
    // Close drawer
    closeDrawer() {
      this.isDrawerOpen = false;
    },

    // Go to detail page

    moveToDetail(checklist) {
      //console.log('postId',postId)
      this.$router.push({
        name: "CheckListView",
        params: { postId: checklist.distribution.id },
        query: { status: checklist.status },
      });
    },
  },
};
</script>


<style scoped>
.t-color-KeyBlue {
  color: var(--KeyBlue) !important;
}

.mdc-chip {
  --mdc-ripple-fg-size: 0;
  --mdc-ripple-left: 0;
  --mdc-ripple-top: 0;
  --mdc-ripple-fg-scale: 1;
  --mdc-ripple-fg-translate-end: 0;
  --mdc-ripple-fg-translate-start: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  will-change: transform, opacity;
  border-radius: 16px;
  background-color: #e0e0e0;
  color: rgba(0, 0, 0, 0.87);
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  letter-spacing: 0.01786em;
  text-decoration: inherit;
  text-transform: inherit;
  height: 24px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  position: relative;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 7px 12px;
  outline: none;
  cursor: pointer;
  overflow: hidden;
}

.top-chip.chip--outlined .mdc-chip.checked {
  background-color: #e3f0ff;
  border: 1px solid var(--KeyBlue);
  color: var(--KeyBlue);
}

.top-chip.chip--outlined .mdc-chip {
  background-color: transparent;
  border: 1px solid var(--Iconinactive);
  color: var(--Iconinactive);
}

.top-chip .mdc-chip {
  line-height: normal;
  height: 30px;
  padding: 8px;
}

.mdc-chip-set .mdc-chip {
  margin: 4px;
}

.top-chip
  .mdc-chip
  .mdc-chip__icon--leading:not(.mdc-chip__icon--leading-hidden) {
  margin-left: -4.5px;
}

.mdc-chip__icon.mdc-chip__icon--leading:not(.mdc-chip__icon--leading-hidden) {
  width: 20px;
  height: 20px;
  font-size: 20px !important;
  margin-right: 4px !important;
}

.mdc-chip.mdc-chip--selected .mdc-chip__checkmark,
.mdc-chip .mdc-chip__icon--leading:not(.mdc-chip__icon--leading-hidden) {
  margin-left: -4px;
  margin-right: 4px;
  margin-top: -4px;
  margin-bottom: -4px;
}
.font-20 {
  font-size: 20px;
}
</style>